module.exports = __webpack_public_path__ + "static/media/2.7386d881.png";